
/**
 * 
 * 
 */
export enum GridTypes {

    /**
     * 
     */
    Filter = 3,

    /**
     * 
     */
    Form = 2,

    /**
     * 
     */
    Tree = 5,

    /**
     * 
     */
    AdvancedGrid = 6,

    /**
     * 
     */
    EasyEdit = 7,

    /**
     * 
     */
    Dashboard = 8,
}
